// src/lib/kbeanApi/getMyHoldings.js
// Filepath: // src/lib/kbeanApi/getMyHoldings.js

import { requestJson } from "../http/request";
import { ApiError } from "../http/errors";

/**
 * Calls the "Get My Holdings" endpoint.
 * Uses REACT_APP_GET_MY_HOLDINGS as the POST URL.
 *
 * Params mirror your sample body; callers can override anything later.
 */

const DEFAULT_BODY = {
  Sort: "{Created: -1}",
  Page: 0,
  Size: 0,
  GroupBy: "artwork",
  FilterMatureArtworks: false,
  FilterKbeanSelectOnly: false,
  Criteria: [],
  ArtworkIds: [],
};

/**
 * @param {Partial<typeof DEFAULT_BODY>} [overrides]
 * @returns {Promise<any>} Raw JSON from API (no normalization yet)
 */
export async function getMyHoldings(overrides = {}) {
  const url = process.env.REACT_APP_GET_MY_HOLDINGS;
  if (!url) {
    throw new ApiError("Missing env REACT_APP_GET_MY_HOLDINGS");
  }

  const body = { ...DEFAULT_BODY, ...overrides };

  // Note: we keep Sort as string to match your sample exactly.
  // If backend accepts JSON sorting later, we can change it during normalization.
  return requestJson(url, {
    method: "POST",
    withAuth: true,
    body,
    timeoutMs: 15000,
  });
}
